var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_128",
    "data-name": "Rectangle 128",
    width: 18,
    height: 18,
    transform: "translate(461.92 864.438)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calender",
    transform: "translate(-461.92 -864.438)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M463.36,871.7v-2.174h14.488V871.7Zm14.515,8.7H463.36v-7.257h14.488v7.257Zm.353-12.34h-6.877v-.924a1.419,1.419,0,0,0,.734-1.223,1.5,1.5,0,0,0-1.467-1.468,1.45,1.45,0,0,0-1.441,1.44,1.387,1.387,0,0,0,.734,1.224v.951h-6.9a1.073,1.073,0,0,0-1.087,1.087v11.606a1.127,1.127,0,0,0,1.087,1.087h15.221a1.127,1.127,0,0,0,1.087-1.087V869.167A1.132,1.132,0,0,0,478.228,868.053Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M465.915,876.044h.734a.329.329,0,0,0,.354-.354v-.733a.329.329,0,0,0-.354-.354h-.734a.328.328,0,0,0-.353.354v.733A.328.328,0,0,0,465.915,876.044Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M468.8,876.044h.734a.329.329,0,0,0,.353-.354v-.733a.328.328,0,0,0-.353-.354H468.8a.329.329,0,0,0-.354.354v.733A.343.343,0,0,0,468.8,876.044Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M471.7,876.044h.734a.329.329,0,0,0,.353-.354v-.733a.328.328,0,0,0-.353-.354H471.7a.329.329,0,0,0-.354.354v.733A.343.343,0,0,0,471.7,876.044Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M474.613,876.044h.733a.329.329,0,0,0,.354-.354v-.733a.329.329,0,0,0-.354-.354h-.733a.329.329,0,0,0-.354.354v.733A.328.328,0,0,0,474.613,876.044Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M465.915,878.925h.734a.329.329,0,0,0,.354-.354v-.733a.329.329,0,0,0-.354-.354h-.734a.329.329,0,0,0-.353.354v.733A.316.316,0,0,0,465.915,878.925Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_126",
    "data-name": "Rectangle 126",
    width: 1.441,
    height: 1.441,
    rx: 0.353,
    transform: "translate(468.443 877.484)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_127",
    "data-name": "Rectangle 127",
    width: 1.441,
    height: 1.441,
    rx: 0.353,
    transform: "translate(471.351 877.484)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M474.613,878.925h.733a.329.329,0,0,0,.354-.354v-.733a.329.329,0,0,0-.354-.354h-.733a.329.329,0,0,0-.354.354v.733C474.232,878.789,474.395,878.925,474.613,878.925Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/Calender.77381305f1ea44b4d18090a7cbed0683.svg";
export { ForwardRef as ReactComponent };